// eslint-disable-next-line @typescript-eslint/naming-convention
export enum ProductType {
  ticket = 'ticket',
  product = 'product',
  donation = 'donation',
  fee = 'fee',
  all = '',
}
